import * as centersPathname from '../../routes/centers/pathname'
import * as purchaseFuelsPathname from '../../routes/purchase-fuels/pathaname'
import * as fuelStations from '../../routes/fuel-stations/pathname'
import { userPathname } from '../../routes/settings/pathname'

import { GROUPS, MODULES } from './roles'

export const cashregisterMenu = [
  {
    id: 'cashRegisters',
    path: '/app/cash-registers',
    module: MODULES.CASHREGISTER,
    group: GROUPS.CASHREGISTER,
  },
]

export const accountingEntryMenu = [
  {
    id: 'accountingEntry',
    path: '/app/accounting-entry-g',
    module: MODULES.ACCOUNTING_ENTRY,
    group: GROUPS.ACCOUNTING_ENTRY,
  },
  {
    id: 'accountingEntry.analyticalDistribution',
    path: '/app/accounting-entry-e',
    module: MODULES.ACCOUNTING_ENTRY,
    group: GROUPS.ACCOUNTING_ENTRY,
  },
  {
    id: 'salaryConcept',
    path: '/app/accounting-entry-c',
    module: MODULES.ACCOUNTING_ENTRY,
    group: GROUPS.ACCOUNTING_ENTRY,
  },
]

export const centersMenu = [
  // {
  //     id: 'centers',
  //     path: centersPathname.mainCentersPathname.CENTERS,
  //     module: MODULES.OWN,
  //     group: GROUPS.CENTERS,
  // },
  {
    id: 'centers.own',
    path: centersPathname.mainCentersPathname.OWNER,
    module: MODULES.CENTERS,
    group: GROUPS.CENTERS,
  },
  {
    id: 'centers.franchise',
    path: centersPathname.mainCentersPathname.FRANCHISE,
    module: MODULES.CENTERS,
    group: GROUPS.CENTERS,
  },
  {
    id: 'centers.other',
    path: centersPathname.mainCentersPathname.OTHER,
    module: MODULES.CENTERS,
    group: GROUPS.CENTERS,
  },

  // {
  //     id: 'centers.other',
  //     path: centersPathname.otherCentersPathname.OTHER_PATH,
  //     module: MODULES.CENTERS,
  //     group: GROUPS.OTHER
  // },
  // {
  //     id: 'centers.franchise',
  //     path: centersPathname.franchiseCentersPathname.FRANCHISE_PATH,
  //     module: MODULES.CENTERS,
  //     group: GROUPS.FRANCHISE
  // },
  // {
  //     id: 'centers.ensenya',
  //     path: centersPathname.ensenyaCentersPathname.ENSENYA_PATH,
  //     module: MODULES.CENTERS,
  //     group: GROUPS.ENSENYA
  // },
  // {
  //     id: 'manuals',
  //     path: centersPathname.centersManuals.MANUALS_PATH,
  //     module: MODULES.CENTERS,
  //     group: GROUPS.MANUALS
  // }
]
// @Deprecated
export const ownCenterMenu = [
  {
    id: 'data',
    path: (id) => centersPathname.ownCenterPathname.DATA(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'services',
    path: (id) => centersPathname.ownCenterPathname.SERVICES(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'technical.data',
    path: (id) => centersPathname.ownCenterPathname.TECHNICAL_DATA(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'employees',
    path: (id) => centersPathname.ownCenterPathname.EMPLOYEES(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'external.companies',
    path: (id) => centersPathname.ownCenterPathname.EXTERNAL_COMPANIES(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'manuals',
    path: (id) => centersPathname.ownCenterPathname.MANUALS(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'maintenance',
    path: (id) => centersPathname.ownCenterPathname.MAINTENANCE(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
  {
    id: 'cash',
    path: (id) => centersPathname.ownCenterPathname.CASH(id),
    module: MODULES.CENTERS,
    group: GROUPS.OWN,
  },
]

// @Deprecated
export const otherCenterMenu = [
  {
    id: 'data',
    path: (id) => centersPathname.otherCenterPathname.DATA(id),
    module: MODULES.CENTERS,
    group: GROUPS.OTHER,
  },
  {
    id: 'businessName',
    path: (id) => centersPathname.otherCenterPathname.BUSINESS(id),
    module: MODULES.CENTERS,
    group: GROUPS.OTHER,
  },
  {
    id: 'services',
    path: (id) => centersPathname.otherCenterPathname.SERVICES(id),
    module: MODULES.CENTERS,
    group: GROUPS.OTHER,
  },
  {
    id: 'technical.data',
    path: (id) => centersPathname.otherCenterPathname.TECHNICAL_DATA(id),
    module: MODULES.CENTERS,
    group: GROUPS.OTHER,
  },
  {
    id: 'contracts',
    path: (id) => centersPathname.otherCenterPathname.CONTRACTS(id),
    module: MODULES.CENTERS,
    group: GROUPS.OTHER,
  },
  {
    id: 'manuals',
    path: (id) => centersPathname.otherCenterPathname.MANUALS(id),
    module: MODULES.CENTERS,
    group: GROUPS.OTHER,
  },
]

// @Deprecated
export const franchiseCenterMenu = [
  {
    id: 'data',
    path: (id) => centersPathname.franchiseCenterPathname.DATA(id),
    module: MODULES.CENTERS,
    group: GROUPS.FRANCHISE,
  },
  {
    id: 'businessName',
    path: (id) => centersPathname.franchiseCenterPathname.BUSINESS(id),
    module: MODULES.CENTERS,
    group: GROUPS.FRANCHISE,
  },
  {
    id: 'services',
    path: (id) => centersPathname.franchiseCenterPathname.SERVICES(id),
    module: MODULES.CENTERS,
    group: GROUPS.FRANCHISE,
  },
  {
    id: 'technical.data',
    path: (id) => centersPathname.franchiseCenterPathname.TECHNICAL_DATA(id),
    module: MODULES.CENTERS,
    group: GROUPS.FRANCHISE,
  },
  {
    id: 'contracts',
    path: (id) => centersPathname.franchiseCenterPathname.CONTRACTS(id),
    module: MODULES.CENTERS,
    group: GROUPS.FRANCHISE,
  },
  {
    id: 'manuals',
    path: (id) => centersPathname.franchiseCenterPathname.MANUALS(id),
    module: MODULES.CENTERS,
    group: GROUPS.FRANCHISE,
  },
]

export const fuelStationsMenu = [
  {
    id: 'summary',
    path: fuelStations.summary.SUMMARY_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.PRICES,
  },

  {
    id: 'margins',
    path: fuelStations.margin.MARGIN_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.PRICES,
  },

  {
    id: 'prices',
    path: fuelStations.pricesFuelStations.PRICE_CHANGES_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.PRICES,
  },
  {
    id: 'tanks',
    path: fuelStations.tanksFuelStations.TANKS_PATH,
    module: MODULES.ALVIC,
    group: GROUPS.TANKS,
  },
  {
    id: 'owns',
    path: fuelStations.ownsFuelStations.OWNS_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.OWN,
  },
  {
    id: 'competencies',
    path: fuelStations.favoritesFuelStations.FAVORITES_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.FAVORITE,
  },
  {
    id: 'fuels.spain',
    path: fuelStations.spainFuelStations.SPAIN_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.FUELSTATIONS,
  },
  {
    id: 'notifications',
    path: fuelStations.notificationsFuelStations.NOTIFICATIONS_PATH,
    module: MODULES.FUELSTATIONS,
    group: GROUPS.NOTIFICATION,
  },
]

export const ownFuelStationsMenu = [
  {
    id: 'data',
    path: (id) => fuelStations.ownFuelStation.DATA(id),
    module: MODULES.FUELSTATIONS,
    group: GROUPS.OWN,
  },
  {
    id: 'competences',
    path: (id) => fuelStations.ownFuelStation.COMPETENCES(id),
    module: MODULES.FUELSTATIONS,
    group: GROUPS.OWN,
  },
  {
    id: 'prices',
    path: (id) => fuelStations.ownFuelStation.PRICES(id),
    module: MODULES.FUELSTATIONS,
    group: GROUPS.OWN,
  },
  {
    id: 'purchase.prices',
    path: (id) => fuelStations.ownFuelStation.PURCHASE_PRICES(id),
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.PROPOSAL,
  },
  {
    id: 'margins',
    path: (id) => fuelStations.ownFuelStation.MARGIN(id),
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.MARGIN,
  },
  {
    id: 'tanks',
    path: (id) => fuelStations.ownFuelStation.TANKS(id),
    module: MODULES.ALVIC,
    group: GROUPS.TANKS,
  },
  {
    id: 'consumption.prediction',
    path: (id) => fuelStations.ownFuelStation.CONSUMPTION_PREVENTION(id),
    module: MODULES.ALVIC,
    group: GROUPS.CONSUMPTION,
  },
]

export const userMenu = [
  {
    id: 'user',
    path: (id) => userPathname.USER(id),
    module: MODULES.USERS,
    group: '',
  },
  {
    id: 'user.job.info',
    path: (id) => userPathname.USER_JOB_INFO(id),
    module: MODULES.USERS,
    group: '',
  },
  {
    id: 'user.private.info',
    path: (id) => userPathname.USER_PRIVATE_INFO(id),
    module: MODULES.USERS,
    group: '',
  },
  {
    id: 'user.settings.rrhh',
    path: (id) => userPathname.USER_SETTINGS_RRHH(id),
    module: MODULES.USERS,
    group: '',
  },
]

export const purchaseFuels = [
  {
    id: 'purchase.needs',
    path: purchaseFuelsPathname.purchaseFuelPathname.PURCHASES_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.NEEDS,
  },
  {
    id: 'shopping.cart',
    path: purchaseFuelsPathname.purchaseFuelPathname.SHOPPING_CART_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.MADE,
  },
  {
    id: 'purchase.suppliers.proposal',
    path: purchaseFuelsPathname.purchaseFuelPathname.SUPPLIERS_PROPOSAL_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.PROPOSAL,
  },
  {
    id: 'summary',
    path: purchaseFuelsPathname.purchaseFuelPathname.SUMMARY_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.NEEDS,
  },
  {
    id: 'purchase.history',
    path: purchaseFuelsPathname.purchaseFuelPathname.HISTORIC_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.MADE,
  },
  {
    id: 'purchase.suppliers',
    path: purchaseFuelsPathname.purchaseFuelPathname.SUPPLIERS_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.SUPPLIERS,
  },
  {
    id: 'notifications',
    path: purchaseFuelsPathname.purchaseFuelPathname.NOTIFICATIONS_PATH,
    module: MODULES.PURCHASE_FUEL,
    group: GROUPS.NOTIFICATION,
  },
]
